import React from 'react';

const LockedTrainingModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '20px'
        }}
        onClick={(e) => {
          // Only close if clicking on backdrop, not on content
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '24px 32px',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center',
          fontFamily: "'Manrope', sans-serif",
          position: 'relative',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }}>

          {/* Title */}
          <h2 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '12px',
            lineHeight: '1.3'
          }}>
            Training Locked
          </h2>

          {/* Description */}
          <p style={{
            fontSize: '14px',
            color: '#6B7280',
            lineHeight: '1.5',
            marginBottom: '24px'
          }}>
            Complete your current training to unlock this one. Focus on your current chapter first!
          </p>

          {/* Button */}
          <div style={{
            display: 'flex',
            justifyContent: 'center'
          }}>
            <button
              onClick={onClose}
              style={{
                padding: '14px 32px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: '#9333EA',
                color: 'white',
                fontWeight: '700',
                fontSize: '16px',
                cursor: 'pointer',
                fontFamily: "'Manrope', sans-serif",
                minWidth: '120px'
              }}
            >
              Got it
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default LockedTrainingModal;